import React from "react";
import { TableContainer, Box } from "@mui/material";
import { useSelector } from "react-redux";

import { ContainerWithLoader } from "../../../../components/ui";
import TableHead from "../TableHead";
import TableBody from "../TableBody";
import { StyledTable } from "../../../../useGeneralStyles";

const TableReport = (): React.ReactElement => {
  const {
    data: { loading, evaluations },
  } = useSelector((state) => state.evaluations);

  return (
    <Box sx={{ overflowX: "scroll" }}>
      <ContainerWithLoader report={evaluations.report} isLoading={loading}>
        <TableContainer sx={{ height: "80vh" }}>
          <StyledTable tableWithoutHover>
            <TableHead />
            <TableBody />
          </StyledTable>
        </TableContainer>
      </ContainerWithLoader>
    </Box>
  );
};

export default TableReport;
